import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { TradingAccount } from '@/api/trading-accounts/use-trading-accounts';
import { type InstrumentType } from '@/utils/leverageOptions';
import { OrderFormContent } from './OrderFormContent';

interface OrderFormDialogProps {
    isOpen: boolean;
    onClose: () => void;
    selectedPair: string;
    selectedInstrumentId?: string;
    realTimePrice?: { bid: number; ask: number; symbol?: string };
    selectedAccount?: TradingAccount | null;
    onOrderSuccess?: () => void;
    isPricesLoading?: boolean;
    pricesError?: string | null;
    instrumentType?: InstrumentType;
    instrumentData?: {
        min_lot: number;
        max_lot: number;
        max_leverage: number;
        leverage: number;
    };
    direction: 'buy' | 'sell';
}

export const OrderFormDialog = (props: OrderFormDialogProps) => {
    const { t } = useTranslation('trading');
    return (
        <Dialog open={props.isOpen} onOpenChange={props.onClose}>
            <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle className="text-xl font-semibold">
                        {props.direction === 'buy' ? t('buy') : t('sell')} {props.selectedPair}
                    </DialogTitle>
                </DialogHeader>

                <OrderFormContent {...props} />
            </DialogContent>
        </Dialog>
    );
};
